import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchField from '../SearchField/SearchField';
import { Tooltip } from '@mui/material';
export default function TableToolbar({
  search,
  actions,
  searchSummary,
  sx = {},
}) {
  if (!search && !actions) {
    return null;
  }

  return (
    <Box
      data-testid="table-toolbar"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        width: '100%',
        ...sx,
      }}
    >
      {search ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: { xs: '100%', sm: 280 }, maxWidth: { xs: '100%', md: 620 } }}>
        <Tooltip title={search.placeholder || 'Search...'} arrow placement="top">
          <SearchField
            placeholder={search.placeholder || 'Search...'}
            value={search.value}
            onChange={(event) => search.onChange?.(event.target.value)}
            fullWidth
            sx={{
              '& input': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            }}
          />
        </Tooltip>
          {searchSummary ? (
            <Typography
              component="span"
              sx={{
                flexShrink: 0,
                color: 'text.secondary',
                fontSize: 13,
                whiteSpace: 'nowrap',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              Total: {searchSummary.totalCount ?? 0} | Unique: {searchSummary.uniquePhoneCount ?? 0}
            </Typography>
          ) : null}
        </Box>
      ) : null}

      {actions ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
            width: { xs: '100%', sm: 'auto' },
            ml: { xs: 0, sm: search ? 'auto' : 0 },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
